import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight, LayoutGrid } from "lucide-react";
import { moduleHref } from "@/mobile/open";

const TILE = "text-left rounded-lg p-3 bg-[var(--m-card)] border border-[var(--m-border)] shadow-[0_1px_2px_rgba(15,17,17,0.06)] active:bg-[var(--m-skeleton)] flex flex-col";
const ICON = "w-9 h-9 rounded-md flex items-center justify-center bg-[#4fc3f7]/15 text-[var(--m-accent-strong)]";

// Home lists the sections (Overview, HR, the departments, Daily Reports) as
// tiles. Tapping one ("/?sec=<key>", same as its chip in the section bar)
// shows that section's module cards.
export default function MobileHome({ groups, section }) {
  const open = section ? groups.find((g) => g.key === section) : null;
  return open ? <SectionCards group={open} /> : <SectionTiles groups={groups} />;
}

function SectionTiles({ groups }) {
  const nav = useNavigate();
  return (
    <div className="p-3 pb-6" data-testid="mobile-home">
      <div className="grid grid-cols-2 gap-2.5">
        {groups.map((g) => {
          const Icon = g.icon || LayoutGrid;
          return (
            <button key={g.key} type="button" onClick={() => nav(`/?sec=${g.key}`)}
              className={`min-h-[104px] ${TILE}`} data-testid={`mobile-section-${g.key}`}>
              <span className={ICON}><Icon className="w-5 h-5" strokeWidth={2} /></span>
              <span className="mt-2 text-[15px] font-bold leading-snug" style={{ fontFamily: "Manrope" }}>{g.label}</span>
              <span className="mt-auto pt-1 text-[12px] text-[var(--m-link)] flex items-center gap-0.5">
                {g.modules.length} {g.modules.length === 1 ? "module" : "modules"}<ChevronRight className="w-3 h-3" />
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

function SectionCards({ group: g }) {
  const nav = useNavigate();
  return (
    <div className="p-3 pb-6" data-testid={`mobile-section-cards-${g.key}`}>
      <div className="flex items-center gap-1 mb-2">
        <button type="button" onClick={() => nav("/")} aria-label="Back to Home" data-testid="mobile-section-back"
          className="shrink-0 w-9 h-9 -ml-1.5 flex items-center justify-center rounded-full active:bg-black/5">
          <ChevronLeft className="w-5 h-5" />
        </button>
        <h2 className="text-[18px] font-bold" style={{ fontFamily: "Manrope" }}>{g.label}</h2>
      </div>
      <div className="grid grid-cols-2 gap-2.5">
        {g.modules.map((m) => (
          <button key={m.to} type="button" onClick={() => nav(moduleHref(m))}
            className={`min-h-[96px] ${TILE}`} data-testid={`mobile-tile-${m.tid || m.to}`}>
            <span className={ICON}>{m.icon && <m.icon className="w-5 h-5" strokeWidth={2} />}</span>
            <span className="mt-2 text-[14px] font-semibold leading-snug">{m.label}</span>
            <span className="mt-auto pt-1 text-[12px] text-[var(--m-link)] flex items-center gap-0.5">
              {m.children?.length ? `${m.children.length} pages` : "Open module"}<ChevronRight className="w-3 h-3" />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
